import { TypesForFormEdited } from '../../interface/Destructuring';

export const FormEdited = (
  { activity, errors, handlerChange, handlerSubmit, }:
    TypesForFormEdited
) => {
  return (
    <div className='form' >
      <form onSubmit={(e) => handlerSubmit(e)} className="formItems">
        <div className="eachElement">
          <label className="label">*Cambiar a: </label>
          <input
            type="text"
            name="name"
            placeholder="Ej: Natación"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          />
          {!activity.name && (
            <span className='errors' >
              <strong>{errors.name}</strong>
            </span>
          )}
        </div>

        <div className="eachElement">
          <label className="label">*Dificultad: </label>
          <select
            name="difficulty"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          >
            <option>Dificultad</option>
            <option value="1">1 - Muy Fácil</option>
            <option value="2">2 - Fácil</option>
            <option value="3">3 - Medio</option>
            <option value="4">4 - Difícil</option>
            <option value="5">5 - Muy Difícil</option>
          </select>
          {errors.name && !activity.difficulty && (
            <span className='errors' >
              <strong>{errors.difficulty}</strong>
            </span>
          )}
        </div>

        <div className="eachElement">
          <label className="label">*Duración: </label>
          <select
            name="duration"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          >
            <option>Duración</option>
            <option value={1}>1 Hora</option>
            <option value={2}>2 Horas</option>
            <option value={3}>3 Horas</option>
            <option value={4}>4 Horas</option>
            <option value={5}>5 Horas</option>
          </select>
          {errors.name && errors.difficulty && (
            <span className='errors' >
              <strong>{errors.duration}</strong>
            </span>
          )}
        </div>

        <div className="eachElement">
          <label className="label">*Temporada: </label>
          <select
            name="season"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          >
            <option>Temporada</option>
            <option value="Verano">Verano</option>
            <option value="Otoño">Otoño</option>
            <option value="Invierno">Invierno</option>
            <option value="Primavera">Primavera</option>
          </select>
          {errors.name && errors.difficulty && errors.duration && (
            <span className='errors' >
              <strong>{errors.season}</strong>
            </span>
          )}
        </div>

        <div className="containSubmit">
          {activity.name &&
            activity.difficulty &&
            activity.duration &&
            activity.season &&
            !(
              errors.name &&
              errors.difficulty &&
              errors.duration &&
              errors.season
            ) ? (
            <button type="submit">
              Editar Actividad
            </button>
          ) : (
            "Llena los campos requeridos (*), para poder Editar la Actividad"
          )}
        </div>
      </form>
    </div>
  )
}
